<template>
    <div class="center">
        <el-popover placement="top" width="160" v-model="visible">
            <p>用户名或密码错误!</p>
            <div style="text-align: right; margin: 0">
                <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
            </div>
        </el-popover>
        <div class="logon">
            <div :class="overlaylong">
                <div class="overlaylong-Signin" v-if="disfiex == 0">
                    <h2 class="overlaylongH2" style="margin-bottom: 20px;">Sign in</h2>
                    <el-input type="text" v-model.trim="userName" placeholder="用户名" prop="userName"></el-input>
                    <el-input type="text" v-model.trim="password" style="margin-top: 20px;" placeholder="密码"
                        show-password @keyup.enter.native="Signup" prop="passwrord"></el-input>
                    <button class="inupbutton" @click="Signup" :loading="isloading">Sign in</button>
                </div>

            </div>
            <div :class="overlaytitle">
                <div class="overlaytitle-Signin" v-if="disfiex == 0">
                    <h2 class="overlaytitleH2">Hello,Friend!</h2>
                    <p class="overlaytitleP">
                        Enter your personal details and start journey with us
                    </p>
                </div>
                <div class="overlaytitle-Signup" v-if="disfiex == 1">
                    <h2 class="overlaytitleH2">Welcome Back!</h2>
                    <p class="overlaytitleP">To keep connected with us please login with your personal info</p>
                    <div class="buttongohs">Sign in</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { Login } from '@/api/userManager'
export default {
    data() {
        return {
            overlaylong: 'overlaylong',
            overlaytitle: 'overlaytitle',
            disfiex: 0,
            userName: '',
            password: '',
            visible: false,
            isloading: false,
            rules: {
                userName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        Signup() {
            this.isloading = true
            if (this.userName !== '' && this.password !== '') {
                let data = {
                    loginAccount: this.userName,
                    loginPassword: this.password
                }
                Login(data).then((res) => {
                    // console.log(res.data)
                    if (res.data.length > 0) {
                        localStorage.setItem('token', 'token')
                        localStorage.setItem('userName',JSON.stringify(res.data))
                        this.$router.push('/')
                    } else {
                        this.visible = true
                    }
                })
            }
            this.isloading = false
        }
    }
}
</script>

<style>
.center {
    width: 1920px;
    height: 1080px;
    background-image: url('../../assets/bg.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

h1 {
    font-size: 30px;
    color: black;
}

.logon {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    /* position: relative;
		overflow: hidden; */
    width: 768px;
    max-width: 100%;
    min-height: 480px;
    margin-top: -50px;
    display: flex;
    background: -webkit-linear-gradient(right, #4284db, #29eac4);
}

.overlaylong {
    border-radius: 10px 0 0 10px;
    width: 50%;
    height: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.overlaylongleft {
    border-radius: 0px 10px 10px 0px;
    width: 50%;
    height: 100%;
    background-color: #fff;
    transform: translateX(100%);
    transition: transform 0.6s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}

.overlaylongright {
    border-radius: 10px 0 0 10px;
    width: 50%;
    height: 100%;
    background-color: #fff;
    transform: translateX(0%);
    transition: transform 0.6s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}

.overlaytitle {
    border-radius: 0px 10px 10px 0px;
    width: 50%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
}


.overlaytitleH2 {
    font-size: 30px;
    color: #fff;
    margin-top: 20px;
}

.overlaytitleP {
    font-size: 15px;
    color: #fff;
    margin-top: 20px;
}

.overlaytitleleft {
    border-radius: 0px 10px 10px 0px;
    width: 50%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(0%);
    transition: transform 0.6s ease-in-out;
}

.overlaytitleright {
    border-radius: 0px 10px 10px 0px;
    width: 50%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(-100%);
    transition: transform 0.6s ease-in-out;
}

.overlaytitle-Signin {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.overlaytitle-Signup {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.buttongohs {
    width: 180px;
    height: 40px;
    border-radius: 50px;
    border: 1px solid #fff;
    color: #fff;
    font-size: 15px;
    text-align: center;
    line-height: 40px;
    margin-top: 40px;
}

.overlaylongH2 {
    font-size: 25px;
    color: black;
    /* width: 250px; */
}

.overlaylong-Signin {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.overlaylong-Signup {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

input {
    background-color: #eee;
    border: none;
    padding: 12px 15px;
    margin: 10px 0;
    width: 240px;
}

h3 {
    font-size: 10px;
    margin-top: 10px;
    cursor: pointer;
}

.inupbutton {
    background-color: #29eac4;
    border: none;
    width: 180px;
    height: 40px;
    border-radius: 50px;
    font-size: 15px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin-top: 30px;
}
</style>
